<template>
  <header class="header" :class="{ 'header--desktop': isDesktop }">
    <div class="container header__inner">
      <router-link to="/" class="header__logo">
        <span class="header__logo-icon" />
        <span class="header__logo-text">
          <span class="header__logo-go">Go</span> Trust
        </span>
      </router-link>
      <button class="header__action btn-primary" @click="$emit('download')">
        {{ isDesktop ? '下载 App' : '打开' }}
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    isDesktop: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['download'],
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--color-bg);
  height: var(--header-height);
  border-bottom: 1px solid var(--color-border);
}

.header--desktop {
  background: var(--color-primary);
  border-bottom: none;
}

.header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.header__logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header__logo-icon {
  width: 28px;
  height: 28px;
  background: var(--color-primary);
  border-radius: 6px;
  flex-shrink: 0;
}

.header--desktop .header__logo-icon {
  background: rgba(255, 255, 255, 0.2);
}

.header__logo-text {
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text);
}

.header--desktop .header__logo-text {
  color: var(--color-white);
}

.header__logo-go {
  position: relative;
}

.header__logo-go::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 3px;
  background: var(--color-accent);
  border-radius: 2px;
}

.header__action {
  padding: 8px 20px;
  font-size: 14px;
}

@media (min-width: 768px) {
  .header__action {
    padding: 8px 24px;
  }
}
</style>
